import React from "react";
import { Link } from "react-router-dom";
import { TEAMS } from "../../constants/TeamDetailsConstant";

function Team({ setTab }) {
  return (
    <section className="ttm-row team-section ttm-bgcolor-grey clearfix">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title title-style-center_text">
              <div className="title-header">
                <h3>Experienced</h3>
                <h2 className="title">Our Eye Specialists</h2>
              </div>
              <div className="heading-seperator">
                <span></span>
              </div>
              <div className="title-desc">
                <p>
                  If you are looking for the best eye specialist near you,
                  doctors at Prasad Eye Hospital will be a preferred choice
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="experts-list">
          {TEAMS?.map((doctor) => (
            <div className="ttm-box-col-wrapper col-lg-6">
              <div className="featured-imagebox featured-imagebox-team style1">
                <div className="featured-thumbnail">
                  <Link
                    to={`/about/${doctor.id}`}
                    onClick={() => setTab("about")}
                  >
                    <img
                      className="img-fluid"
                      src={doctor.img}
                      alt={doctor.imgAlt}
                    />
                  </Link>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>
                      <Link
                        to={`/about/${doctor.id}`}
                        onClick={() => setTab("about")}
                      >
                        {doctor.name}
                      </Link>
                    </h3>
                  </div>
                  <div className="team-position">
                    <Link
                      to={`/about/${doctor.id}`}
                      onClick={() => setTab("about")}
                    >
                      {doctor.profession}
                    </Link>
                  </div>
                </div>
                <div className="ttm-team-bottom-content padding_top0">
                  <Link
                    to={`/about/${doctor.id}`}
                    onClick={() => setTab("about")}
                  >
                    <span className="margin_left10 margin_right10">
                      {doctor.summary}
                    </span>
                  </Link>
                  <div className="ttm-btn-bottom">
                    <Link
                      to="/appointment"
                      className="ttm-btn btn-inline ttm-btn-size-md  ttm-btn-color-skincolor font-weight-500"
                      onClick={() => setTab("appointment")}
                    >
                      Book Appointment
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
